import axios from 'axios';

export const ssrsReport = async (reportTypeID, queryObjectID, termSchoolID, week, showCRN, showConflicts) => {
    axios({
        url: `/api/SSRS/Report?reportTypeID=${reportTypeID}&queryObjectID=${queryObjectID}&termSchoolID=${termSchoolID}&week=${week}&warmUp=false&showCRN=${showCRN}&showConflicts=${showConflicts}`,
        method: 'GET',
        responseType: 'blob'
    }).then((response) => {
        const localUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = localUrl;
        link.setAttribute('download', 'Timetable.pdf');
        document.body.appendChild(link);
        link.click();
    });
};

/*
 * SetID is 0 as there would never be a Set with the primary id of 0 in the database
 */
export const warmUpSSRS = async () => {
    const endpoint = `/api/SSRS/Report?reportTypeID=${0}&queryObjectID=${0}&termSchoolID=${0}&week=${0}&warmUp=true&showCRN=false&showConflicts=false`;

    const result = await axios.get(endpoint);
    return result;
};
